/* ===========================================================================
   ROSSI — PDP runtime fixes (v2)
   Scope: body.template-v2 product pages. Diagnosed 2026-06-09..11.

   Three variant-change-related defects (see /products/tahoe-outdoor-patio-
   patio-aluminum-counter-stool):

   (A) GROWING WHITE GAP — Notify Me app appends a classless empty <div> into
       .product-form__inner (display:flex; gap:16px) on every variant change
       and never removes it; each empty flex item adds a 16px row-gap. Fix:
       hide classless/id-less empty direct-child divs (self-correcting CSS).

   (B) BROKEN GALLERY THUMBNAILS — some Rio thumbnails finish complete &&
       naturalWidth===0 though the URL returns HTTP 200 (initial load raced/
       aborted). Fix: NON-DESTRUCTIVELY heal — preload the URL off-DOM via
       new Image(); only once it is cached do we refresh the live <img> (an
       instant cache hit, no visible blank). If it genuinely cannot be fetched,
       the live <img> is left untouched. Never blanks a working image.

   (C) PRE-ORDER APP <style> LEAK — duplicate .BDTLL_* <style> tags injected
       into <head> per variant change. Fix: drop exact duplicates.

   v2 perf notes (2026-06-11): removed the document-wide MutationObserver that
   ran during the heavy initial load; the gallery heal now uses timed passes +
   a gallery-SCOPED observer, and BDTLL de-dupe uses a cheap head-only observer.
   =========================================================================== */
(function rossiPdpFixes() {
  'use strict';

  function isV2() { return document.body && document.body.classList.contains('template-v2'); }

  /* (A) inject the gap-fix CSS once */
  function injectGapCss() {
    if (document.getElementById('rossi-pdp-fixes-css')) return;
    var s = document.createElement('style');
    s.id = 'rossi-pdp-fixes-css';
    s.textContent = 'body.template-v2 .product-form__inner > div:empty:not([class]):not([id]){display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  /* (B) heal errored gallery imgs — NON-DESTRUCTIVE, one at a time, max 3 tries */
  var healQ = [], healBusy = false;
  function healImages() {
    var imgs = document.querySelectorAll('.product__media-container img, .pwzrjss5 img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.complete && im.naturalWidth === 0 && (im.getAttribute('src') || im.currentSrc)
          && !im.__rossiInQ && (im.__rossiAttempts || 0) < 3) {
        im.__rossiInQ = true;
        healQ.push(im);
      }
    }
    pumpHeal();
  }
  function pumpHeal() {
    if (healBusy) return;
    var im = null;
    while (healQ.length) { var c = healQ.shift(); c.__rossiInQ = false; if (c.complete && c.naturalWidth === 0) { im = c; break; } }
    if (!im) return;
    healBusy = true;
    im.__rossiAttempts = (im.__rossiAttempts || 0) + 1;
    var u = im.getAttribute('src') || im.currentSrc, settled = false;
    function fin() { if (settled) return; settled = true; healBusy = false; setTimeout(pumpHeal, 80); }
    /* Preload off-DOM first; only refresh the live img from cache once ready. */
    var pre = new Image();
    pre.onload = function () {
      try { if (im.complete && im.naturalWidth === 0) { im.removeAttribute('src'); im.src = u; } } catch (e) {}
      fin();
    };
    pre.onerror = fin; /* genuinely unfetchable -> leave the live img alone */
    try { pre.src = u; } catch (e) { fin(); return; }
    setTimeout(fin, 3000); /* safety */
  }

  /* (C) remove exact-duplicate BDTLL <style> tags (keep newest = last in DOM) */
  function dedupeBdtllStyles() {
    var arr = [].slice.call(document.querySelectorAll('style')).reverse();
    var seen = {};
    for (var i = 0; i < arr.length; i++) {
      var st = arr[i];
      var t = st.textContent || '';
      if (t.indexOf('BDTLL') === -1) continue;
      if (seen[t]) { if (st.parentNode) st.parentNode.removeChild(st); }
      else seen[t] = 1;
    }
  }

  function pass() {
    injectGapCss();
    if (!isV2()) return;
    healImages();
    dedupeBdtllStyles();
  }

  function run() {
    injectGapCss();
    if (!isV2()) return;
    pass();

    /* Rio mounts late + variant images stream in. Timed passes (incl. later
       ones for slow galleries) instead of a document-wide observer. */
    [500, 1500, 3500, 6000, 10000].forEach(function (ms) { setTimeout(pass, ms); });

    /* re-run after each variant change (debounced) */
    var deb = null;
    function onVar() {
      if (deb) clearTimeout(deb);
      deb = setTimeout(function () { healImages(); dedupeBdtllStyles(); }, 300);
    }
    ['variant:change', 'variant:changed', 'product:variant-change', 'product:variant:change',
     'flu:product:variant-change', 'shopify:variantChanged', 'variantChanged',
     'productVariantChange', 'rio:variant-change'].forEach(function (ev) {
      document.addEventListener(ev, onVar, true);
    });
    var sel = document.querySelector('form[action*="/cart/add"] select[name="id"], form[data-product-form] select[name="id"]');
    if (sel) sel.addEventListener('change', onVar);

    /* heal late-mounting Rio thumbnails — observe ONLY the gallery container
       (scoped + auto-disconnect; no document-wide observation during load). */
    try {
      var media = document.querySelector('.product__media-container');
      if (media) {
        var galMo = new MutationObserver(function () { setTimeout(healImages, 150); });
        galMo.observe(media, { childList: true, subtree: true });
        setTimeout(function () { galMo.disconnect(); }, 20000);
      }
    } catch (e) {}

    /* BDTLL <style> tags re-inject into <head> on later variant changes too —
       cheap, persistent head-only observer keeps them de-duped (head childList
       rarely mutates). */
    try {
      var headMo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var an = muts[i].addedNodes;
          for (var j = 0; j < an.length; j++) {
            var n = an[j];
            if (n.nodeType === 1 && n.tagName === 'STYLE' && (n.textContent || '').indexOf('BDTLL') > -1) {
              dedupeBdtllStyles();
              return;
            }
          }
        }
      });
      headMo.observe(document.head || document.documentElement, { childList: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
